import type { ISimpleEvent } from "ste-simple-events";
import type { IHRLoginOptions } from "./backends/ihm";

// IHRAL-6891 accountType could be undefined (ios) so making it optional
export interface IHeartUserProfile {
    accountType?: string;
    profileId?: number;
    sessionId?: string;
    name?: string;
    email?: string;
    phoneNumber?: number;
    zipCode?: any;
    gender?: string;
    birthDay?: number;
    birthMonth?: number;
    birthYear?: number;
    userImage?: string;
    marketName?: string;
    privacyCompliance?: {
        privacyCompliance?: string[];
    };
}

export interface SessionState {
    authenticated: boolean;
    pid: string;
    aid: string;
}

export interface IHRSessionState extends SessionState {
    profile?: IHeartUserProfile;
}

export function isIHRSession(v?: any | undefined | null): v is IHRSessionState {
    return !!(
        v &&
        v.hasOwnProperty("profile") &&
        v.profile &&
        v.profile.hasOwnProperty("accountType") &&
        v.profile.accountType
    );
}

export interface IHRInitialize {
    alwaysPrompt: boolean;
    container: string;
    embed: boolean;
    host: string;
    iframe?: HTMLIFrameElement | null | undefined;
    iframeId: string;
}

export interface SessionBackend<T = IHRSessionState, U = IHRLoginOptions> {
    name: string;
    state: T;
    onStatusChanged: ISimpleEvent<T>;
    authenticated: boolean;
    container?: string;
    login(options?: Partial<U>): Promise<T>;
    signup(options?: Partial<U>): Promise<T>;
    logout(): Promise<T>;
    refresh(): Promise<T>;
}

export type IHRPromiseValue = string | object | Error | null | undefined;

export interface IHRCallback {
    success: (result: string) => void;
    error: (error: string) => void;
}

export interface IHRStatusResponse {
    aid: string;
    pid: string;
    auth?: string;
}
